import type { DealFixedRateLoanData, DealFloatingRateLoanData } from '@src/types/OTC';
import { getOtcDealLoanAmountDisplayValue } from '@src/utils/OTC/otcDealDisplayUtils';
import type { OTCFixedRateLoanSecurity, OTCFloatingRateLoanSecurity } from '@talos/kyoko';
import { InspectorNumberDisplay } from './InspectorNumberDisplay';

interface LoanAmountDisplayProps {
  instrumentData: DealFixedRateLoanData | DealFloatingRateLoanData;
  dealSecurity: OTCFixedRateLoanSecurity | OTCFloatingRateLoanSecurity;
}

export const LoanAmountDisplay = ({ instrumentData, dealSecurity }: LoanAmountDisplayProps) => {
  const { value, currency } = getOtcDealLoanAmountDisplayValue(instrumentData, dealSecurity);
  return <InspectorNumberDisplay value={value} currency={currency} />;
};
